<template>
  <div class="page live-list">
    <div class="container">
      <div class="section live">
        <Live />
      </div>
      <div class="section live">
        <LiveHistory :is-mobile="isMobile" />
      </div>
    </div>
  </div>
</template>

<script>
/* 组件 */
import Customdialog from "@/components/customdialog.vue"
import Live from "./live.vue"
import LiveHistory from "./live-history.vue"
/* 方法 */
export default {
  name: "LiveList",
  components: {
    Customdialog,
    Live,
    LiveHistory
  },
  data() {
    return {
      infoData: {},
      isMobile: false, // 判断手机端字段
    }
  },
  computed: {},
  created() {
    this.getBrowserMobile()
  },
  mounted() { },
  methods: {
    // 判断浏览环境是手机端和pc端
    getBrowserMobile() {
      const regBrowser =
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      this.isMobile = navigator.userAgent.match(regBrowser) ? true : false // 判断是否是手机浏览
      return this.isMobile
    },
  },
};
</script>
<style scoped lang="scss">
.page {
  width: 100%;
  max-width: 1800px;
  margin: 0 auto 30px;
  overflow: hidden;

  .container {
    margin-top: 36px;

    .section {
      max-width: 1800px;
    }
  }
}

@media screen and (max-width: 640px) {
  .page {
    padding: 0 10px;
    box-sizing: border-box;

    .container {
      margin-top: 15px;
    }
  }
}
</style>